// @file Vuex plugin that listens/triggers changes in the address
import { getSectionBreakoutPath, getSectionBreakoutPostPath } from '@@/bits/surface_share_links_helper'
import type { RootState } from '@@/vuexstore/surface/types'
import type { MutationPayload, Store } from 'vuex'

const history = window.history

export default (store: Store<RootState>): void => {
  const getters = store.getters

  const watchExpandedPost = (_mutation: MutationPayload, state: RootState): void => {
    if (
      !state.post.isInitialPaginatedDataLoadDone ||
      getters.isSlideshow ||
      getters.isSubmissionRequest ||
      getters.isGeneratingPDF
    ) {
      return
    }

    let newPathname = ''
    // Fix an issue with browser being able to load URL with multiple slashes
    // e.g. https://padlet.com//about/us
    const originalPathname = window.location.pathname.replace(/(\/)\1+/g, '$1')

    if (state.postAction.expandedPostCid) {
      const expandedPostServerId = getters['postAction/expandedPostServerId']
      if (expandedPostServerId == null) return
      if (getters.isSectionBreakout as boolean) {
        newPathname = getSectionBreakoutPostPath(
          state.wall.namespace,
          state.sectionBreakoutIdentifier ?? '',
          expandedPostServerId,
        )
      } else {
        newPathname = '/' + getters.address + '/wish/' + expandedPostServerId
      }

      if (window.location.pathname !== newPathname) {
        history.pushState(
          {
            expandedPostCid: state.postAction.expandedPostCid,
            expandedPostServerId,
          },
          '',
          newPathname,
        )
      }
    } else {
      if (getters.isSectionBreakout as boolean) {
        newPathname = getSectionBreakoutPath(state.wall.namespace, state.sectionBreakoutIdentifier ?? '')
      } else if (state.isEmbedded) {
        newPathname = '/embed/' + getters.publicKey
      } else {
        newPathname = '/' + getters.address
      }
      if (originalPathname !== newPathname) {
        if (history.state && history.state.expandedPostServerId) {
          history.pushState({}, '', newPathname)
        } else {
          const pathSplited = originalPathname.split('/')
          const expandedPostServerId = pathSplited[pathSplited.length - 1]
          const expandedPostCid =
            store.getters['post/getPostByServerId'](expandedPostServerId)?.cid || `c${expandedPostServerId}`
          history.replaceState({ expandedPostCid, expandedPostServerId }, '', originalPathname)
          history.pushState({}, '', newPathname)
        }
      }
    }
  }

  let unsubscribeFromWatchingExpandedPost = store.subscribe(watchExpandedPost)

  window.addEventListener('popstate', (e) => {
    const eventState = e.state
    unsubscribeFromWatchingExpandedPost()
    if (eventState && eventState.expandedPostCid) {
      store.dispatch({
        type: 'postAction/expandPost',
        postCid: eventState.expandedPostCid,
        xTextPanel: true,
      })
    } else {
      store.dispatch({
        type: 'postAction/unexpandPost',
      })
    }
    unsubscribeFromWatchingExpandedPost = store.subscribe(watchExpandedPost)
  })
}
